import React from "react";
import CmsPages from "../../common/CMSPages/CmsPages";
const Testimonials = () => {
  return <CmsPages cmsId={3} pageTitle="Testimonials" />;
};
export default Testimonials;
